export default __webpack_public_path__ + "static/media/LPG Pipeline1.76e9a9df.webp";